import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import striptags from 'striptags';
import { IconCommentLine, IconCommentSolid } from '@instructure/ui-icons';
import { IconButton } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
var EditAnswerFeedbackButton = /*#__PURE__*/function (_Component) {
  function EditAnswerFeedbackButton() {
    var _this2;
    _classCallCheck(this, EditAnswerFeedbackButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, EditAnswerFeedbackButton, [].concat(args));
    _defineProperty(_this2, "button", null);
    // ================
    //   PUBLIC UTILS
    // ================
    _defineProperty(_this2, "focus", function () {
      _this2.button.focus();
    });
    _defineProperty(_this2, "generateText", function () {
      if (_this2.props.iconFilled) {
        return t('Edit Answer Feedback: {choice}, feedback present', {
          choice: striptags(_this2.props.itemBody)
        });
      } else {
        return t('Edit Answer Feedback: {choice}, no feedback present', {
          choice: striptags(_this2.props.itemBody)
        });
      }
    });
    // ============
    //   HANDLERS
    // ============
    _defineProperty(_this2, "handleRef", function (node) {
      _this2.button = node;
    });
    _defineProperty(_this2, "handleClick", function (event) {
      _this2.props.onEditChoiceFeedback(_this2.props.choiceId);
      var expanded = _this2.props.expanded ? t('Answer feedback editor closed') : t('Answer feedback editor opened');
      _this2.props.notifyScreenreader(expanded);
    });
    return _this2;
  }
  _inherits(EditAnswerFeedbackButton, _Component);
  return _createClass(EditAnswerFeedbackButton, [{
    key: "render",
    value:
    // ===========
    //   RENDERS
    // ===========

    function render() {
      var text = this.generateText();
      return /*#__PURE__*/React.createElement(IconButton, {
        name: this.props.choiceId,
        withBackground: false,
        withBorder: false,
        onClick: this.handleClick,
        ref: this.handleRef,
        size: "medium",
        renderIcon: this.props.iconFilled ? IconCommentSolid : IconCommentLine,
        label: text,
        screenReaderLabel: text,
        "data-automation": this.props.automationData || "sdk-edit-answer-feedback-".concat(this.props.choiceId, "-button")
      });
    }
  }]);
}(Component);
_defineProperty(EditAnswerFeedbackButton, "propTypes", {
  choiceId: PropTypes.string.isRequired,
  iconFilled: PropTypes.bool,
  onEditChoiceFeedback: PropTypes.func,
  itemBody: PropTypes.string.isRequired,
  notifyScreenreader: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  automationData: PropTypes.string
});
_defineProperty(EditAnswerFeedbackButton, "defaultProps", {
  onEditChoiceFeedback: function onEditChoiceFeedback() {},
  iconFilled: false
});
export { EditAnswerFeedbackButton as default };